import React from 'react';

/**
 * custom event to call given parameter callback when the user pressed the keyboard "Enter" key
 * @param onEnter event to trigger upon successful "Enter" pressed
 */
export function onKeyboardEnter(onEnter: (e: React.KeyboardEvent) => void) {
  return (e: React.KeyboardEvent) => {
    /**
     * e.keyCode => determine the button was pressed with a keyboard "Enter" key.
     * ref: https://www.w3schools.com/howto/howto_js_trigger_button_enter.asp
     */
    if (e.keyCode !== 13) {
      // ==> continue the navigation only on "Enter" press
      return;
    }
    return onEnter(e);
  };
}

/**
 * custom event to call given parameter callback when the user pressed the keyboard "tab" key
 * @param onTab event to trigger upon successful "tab" pressed
 */
export function onTabClick(onTab: (e: React.KeyboardEvent) => void) {
  return (e: React.KeyboardEvent) => {
    if (e.keyCode !== 9) {
      // ==> continue the navigation only on "Tab" press
      return;
    }
    return onTab(e);
  };
}

/**
 * custom event to call given parameter callback when the user clicks the left mouse button
 * @param onClick *event to trigger upon successful left click
 */
export function onMouseLeftClick(onClick: (e: React.MouseEvent) => void) {
  return (e: React.MouseEvent) => {
    /**
     * e.button => determine the button click that was selected.
     * left button click = 0, middle button click = 1 (if present), right button click = 2
     * ref: https://stackoverflow.com/questions/47737404/detecting-left-and-right-mouse-events-for-a-canvas-game
     */
    if (e.button !== 0) {
      // ==> continue the navigation only on left click
      return;
    }
    return onClick(e);
  };
}
